var _path, _path2, _rect, _rect2, _path3, _ellipse, _ellipse2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEstateAllServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.827 44.6873L86.2941 7.85645L62.3555 36.2126V102.144H104.827V44.6873Z",
    fill: "#BFD9F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0625 43.2129H65.1859V102.142H0.0625V43.2129Z",
    fill: "#EAF5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.7129,
    y: 60.8926,
    width: 16.9887,
    height: 17.6788,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.3438,
    y: 66.7861,
    width: 14.1573,
    height: 35.3577,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.023 7.85645H22.2558L0.0625 43.2141H65.186L86.023 7.85645Z",
    fill: "#00C968"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.6186,
    cy: 43.358,
    rx: 24.4448,
    ry: 19.2066,
    fill: "#B2B2B2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.6186,
    cy: 39.8648,
    rx: 24.4448,
    ry: 19.2066,
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6335 48.8105L74.1217 32.9023H77.9303L80.7428 44.0938H80.8893L83.7311 32.9023H87.5104L90.3815 44.0352H90.528L93.3112 32.9023H97.1198L92.6081 48.8105H88.7116L85.7233 38.0293H85.5182L82.5299 48.8105H78.6335Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstateAllServiceMain);
export default __webpack_public_path__ + "static/media/IcEstateAllServiceMain.a9f8ad034850a1d76f79df1a50b66490.svg";
export { ForwardRef as ReactComponent };